import { createFileRoute } from "@tanstack/react-router";
import { EnergiPage, energiHead } from "@/pages/EnergiPage";

export const Route = createFileRoute("/en/industries/energy-infrastructure")({
  head: () => energiHead("en"),
  component: () => <EnergiPage locale="en" />,
});
